import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import { useMediaQuery, mediaQueries } from "hooks/useMediaQuery";
import { Link } from "components/core/Link";
import { ClickToCall } from "components/brand/ClickToCall";
import {
	storageUnitsNearMe,
	storageTypes
} from "config/headerMenuLinks";
import { Button } from "components/core/Button";
import HeaderMenu from "components/brand/Header/HeaderMenu";
import { Chevron } from "components/core/Icons";
import Logo from "assets/images/full-logo.svg";
import { useTollfreeNumber } from "hooks/useTollfreeNumber";
import "./Header.scss";

function Header() {
	const [belowLarge] = useMediaQuery([mediaQueries.belowLarge]);
	const [expanded, setExpanded] = useState(false);
	// the name of the currently open menu, enables toggling between open menus
	const [openMenuName, setOpenMenuName] = useState(null);
	const handleExpand = () => setExpanded(!expanded);
	const useMobileMenu = expanded && belowLarge;
	const { phone, handleFetchNumber } = useTollfreeNumber();
	const headerRef = useRef(null);

	useEffect(() => {
		if (!openMenuName) return undefined;

		const handleClickOutside = (event) => {
			if (headerRef.current && !headerRef.current.contains(event.target)) {
				setOpenMenuName(null);
				setExpanded(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		document.addEventListener("touchstart", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
			document.removeEventListener("touchstart", handleClickOutside);
		};
	}, [openMenuName, belowLarge]);
	return (
		<div className="header" ref={headerRef}>
			<div className="left-section">
				<Link
					last
					className="logo-link"
					href="/"
					underline={false}
				>
					<img
						className="icon svg logo"
						alt="icon"
						src={Logo}
						width="206"
						height="45"
					/>
				</Link>
				{belowLarge && (
					<Button
						title={`${
							expanded ? "Close" : "Open"
						} main navigation menu`}
						onClick={handleExpand}
						className={classnames("button-menu", {
							"button-expanded": expanded,
							"button-collapsed": !expanded
						})}
					>
						<Chevron rotate={expanded ? "up" : "down"} />
					</Button>
				)}
			</div>
			<div
				className={classnames("dropdown-menu", {
					"mobile-menu": useMobileMenu
				})}
			>
				{[storageUnitsNearMe, storageTypes].map(
					({ menuName, links, sections, footerLink }) => (
						<HeaderMenu
							key={menuName}
							isStacked={useMobileMenu}
							menuName={menuName}
							links={links}
							sections={sections}
							footerLink={footerLink}
							openMenuName={openMenuName}
							setOpenMenuName={setOpenMenuName}
						/>
					)
				)}
			</div>
			<div className="right-section">
				<ClickToCall
					handleFetchNumber={handleFetchNumber}
					phone={phone}
				/>
			</div>
		</div>
	);
}

export default Header;
